export default __webpack_public_path__ + "static/media/file.ec863f4b.svg";